import {
    Component,
    ComponentRef,
    Input,
    ViewChild,
    ViewContainerRef,
    OnDestroy,
    AfterViewInit,
    Type,
  } from '@angular/core';
  import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
  @Component({
    selector: 'app-shared-modal',
    templateUrl: './shared-modal.component.html',
    styleUrls: ['./shared-modal.component.scss'],
    standalone: false
})
  export class SharedModalComponent implements AfterViewInit, OnDestroy {
    @Input() contentComponent: Type<any>; // The dynamic component to display inside modal
    @Input() data?: any;                  // Optional data passed into the dynamic component
  
    @ViewChild('modalContent', { read: ViewContainerRef }) modalContentRef: ViewContainerRef;
  
    componentRef: ComponentRef<any>;
  
    constructor(public activeModal: NgbActiveModal) {}
  
    ngAfterViewInit(): void {
      if (this.contentComponent && this.modalContentRef) {
        this.modalContentRef.clear(); 
  
        // Create and inject the dynamic component into <ng-template>
        this.componentRef = this.modalContentRef.createComponent(this.contentComponent);
  
        // Pass input data into the component instance (e.g., form title or success message)
        if (this.data) {
          Object.assign(this.componentRef.instance, this.data);
        }
  
        // Optional: allow the component to trigger `close()` via this.activeModal
        if (this.componentRef.instance['close']) {
          this.componentRef.instance['close'] = () => this.activeModal.close();
        }
      }
    }
  
    ngOnDestroy(): void {
      // Clean up if component is destroyed
      if (this.componentRef) {
        this.componentRef.destroy();
      }
    }
  }
  